import { render, staticRenderFns } from "./page-picker.vue?vue&type=template&id=c3f1edae&scoped=true&"
import script from "./page-picker.vue?vue&type=script&lang=ts&"
export * from "./page-picker.vue?vue&type=script&lang=ts&"
import style0 from "./page-picker.vue?vue&type=style&index=0&id=c3f1edae&lang=scss&scoped=true&"
import style1 from "./page-picker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f1edae",
  null
  
)

export default component.exports